import axios from 'axios'

export default {
  createOrder(order) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BACKEND_URL + '/orders',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      withCredentials: false,
      data: order
    })
  }
}
